import { AppButton, PasswordInputField } from 'components';
import { useState } from 'react';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import useToaster from 'hooks/useToaster';
import useChangePassword from 'hooks/API/useChangePassword';

function ChangePassword() {
  const { mutate, isLoading, isError } = useChangePassword();

  const [oldPassword, handleOldPassword] = useState('');
  const [newPassword, handleNewPassword] = useState('');
  const [confirmPassword, handleConfirmPassword] = useState('');
  const [formErrors, setFormErrors] = useState([]);

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function handleChangePassword() {
    if (isLoading) return;

    setFormErrors([]);

    const data = {
      oldPassword,
      newPassword,
      confirmPassword,
      bundleId: false,
    };

    const validation = manageChange_PasswordSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    mutate(data);

    clearData();
  }

  function clearData() {
    setFormErrors([]);

    handleOldPassword('');
    handleNewPassword('');
    handleConfirmPassword('');
  }

  const errors = checkForErrors(formErrors);

  return (
    <>
      <div className="mainWraper">
        <div className="container-fluid outerborder">
          <div className="row">
            <div className="col-6">
              <h2 className="prime-head p-0 boldtitle">Change Password</h2>
            </div>
            <div className="col-6 prime-head text-right"></div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <PasswordInputField
                labelProps={{
                  label: 'Old password *',
                  htmlFor: 'oldPassword',
                }}
                inputProps={{
                  placeholder: 'Old password *',
                  id: 'oldPassword',
                  name: 'oldPassword',
                  value: oldPassword,
                  onChange: (event) => handleOldPassword(event.target.value),
                }}
                fieldErrors={errors['oldPassword']}
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <PasswordInputField
                labelProps={{
                  label: 'New password *',
                  htmlFor: 'newPassword',
                }}
                inputProps={{
                  placeholder: 'New password *',
                  id: 'newPassword',
                  name: 'newPassword',
                  value: newPassword,
                  onChange: (event) => handleNewPassword(event.target.value),
                }}
                fieldErrors={errors['newPassword']}
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <PasswordInputField
                labelProps={{
                  label: 'Confirm password *',
                  htmlFor: 'confirmPassword',
                }}
                inputProps={{
                  placeholder: 'Confirm password *',
                  id: 'confirmPassword',
                  name: 'confirmPassword',
                  value: confirmPassword,
                  onChange: (event) => handleConfirmPassword(event.target.value),
                }}
                fieldErrors={errors['confirmPassword']}
              />
            </div>
          </div>
          <div className="d-flex flex-row mt-4">
            <div className="aligncenter savecancelbtnsec">
              <AppButton
                variantClass="btn-primary mx-3"
                style={{ minWidth: '1.5rem' }}
                onClick={handleChangePassword}
                disabled={isLoading}
              >
                Submit
              </AppButton>
              <AppButton variantClass="btn-plane p--tint mx-3" onClick={clearData}>
                Cancel
              </AppButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const manageChange_PasswordSchema = Joi.object({
  oldPassword: Joi.string().required().trim(),
  newPassword: Joi.string().required().trim(),
  confirmPassword: Joi.string().required().valid(Joi.ref('newPassword')),
});

export default ChangePassword;
